/** Shown while Clerk loads or /admin/me is in flight. */
export function Splash() {
  return (
    <div className="grid min-h-screen place-items-center bg-background text-sm text-muted-foreground">
      Loading…
    </div>
  );
}
